function InitializeQtip() {
    InitializeGenericQTip();
    InitializeCMS();
    InitializeAddToCartPopup();
}

function InitializeGenericQTip() {
    $(".qTip").each(function () {
        var $qTip = $(this);

        var params = {
            /* element that contains information to show inside of qTip */
            contentElement: $qTip.attr("data-contentElement"),

            /* relationship that element with .qTip has with contentElement (child, sibling), default: child */
            contentRelationship: $qTip.attr("data-contentRelationship") == undefined || $qTip.attr("data-contentRelationship") == "child" ? "child" : $qTip.attr("data-contentRelationship"),

            /* string to be displayed in title of qTip */
            title: $qTip.attr("data-title"),

            /* showing and hiding of qTip triggered by clicking (true, false), default: false */
            operateManually: $qTip.attr("data-showHideOnClick") == undefined || $qTip.attr("data-showHideOnClick") == "false" ? false : true,

            myPosition: $qTip.attr("data-myPosition"),

            atPosition: $qTip.attr("data-atPosition"),

            /* qTip classes to change appearance of qTip; jquery.qtip.css */
            classes: $qTip.attr("data-classes"),

            /* time in ms to delay before showing qTip */
            delayOnShow: $qTip.attr("data-delayOnShow") == undefined ? 0 : $qTip.attr("data-delayOnShow"),

            /* time in ms to delay before hiding qTip */
            delayOnHide: $qTip.attr("data-delayOnHide") == undefined ? 0 : $qTip.attr("data-delayOnHide"),

            /* should qTip arrow be shown or not (true, false) */
            showArrow: $qTip.attr("data-showArrow") == undefined || $qTip.attr("data-showArrow") == "true" ? true : false,

            /* the class that the target of the qTip should be changed to when qTip is triggered */
            classChange: $qTip.attr("data-classChange"),

            /* the container id for the bounds of the qTip */
            viewPort: $qTip.attr("data-viewport") == undefined || $qTip.attr("data-viewport") == "window" ? $(window) : $("#" + $qTip.attr("data-viewport")),

            adjustMethod: $qTip.attr("data-adjustMethod") == undefined ? "flip" : $qTip.attr("data-adjustMethod"),
            
            showOnLoad: $qTip.attr("data-showOnLoad") == undefined || $qTip.attr("data-showOnLoad") == "false" ? false : true,

            target: $qTip.attr("data-target") == undefined ? false : $("#" + $qTip.attr("data-target")),

            adjustXCoord: $qTip.attr("data-adjustXCoord") == undefined ? 0 : parseInt($qTip.attr("data-adjustXCoord"), 10) || 0,
            adjustYCoord: $qTip.attr("data-adjustYCoord") == undefined ? 0 : parseInt($qTip.attr("data-adjustYCoord"), 10) || 0,

            showSolo: $qTip.attr("data-showSolo") == undefined || $qTip.attr("data-showSolo") == "false" ? false : true,
            
            width: $qTip.attr("data-width") == undefined || $qTip.attr("data-width") == "false" ? false : $qTip.attr("data-width"),
            
            trackEvent: $qTip.attr("data-trackEvent") == undefined || $qTip.attr("data-trackEvent") == "false" ? false : true,
            
            trackEventName: $qTip.attr("data-trackEventName") == undefined ? "" : $qTip.attr("data-trackEventName"),
            
            trackEventAction: $qTip.attr("data-trackEventAction") == undefined ? "" : $qTip.attr("data-trackEventAction"),
            
        };

        var $qTipHoverElement = $(this);

        if (params.contentRelationship == "sibling") {
            $qTipHoverElement = $(this).siblings(params.contentElement);
        }
        else if (params.contentRelationship == "child") {
            $qTipHoverElement = $(this).children(params.contentElement);
        }
        else if (params.contentRelationship == "child-find") {
            $qTipHoverElement = $(this).children().find(params.contentElement);
        }
        
        $qTip
            .removeData("qtip")
            .qtip({
                overwrite: false,
                content: {
                    text: $qTipHoverElement,
                    title: {
                        text: params.title,
                        button: params.operateManually
                    }
                },
                position: {
                    my: params.myPosition,
                    at: params.atPosition,
                    viewport: params.viewPort,
                    target: params.target,
                    adjust: {
                        method: params.adjustMethod,
                        x: params.adjustXCoord,
                        y: params.adjustYCoord
                    }
                },
                style: {
                    //height: 100,
                    classes: params.classes + ' ui-tooltip-rounded',
                    tip: {
                        corner: params.showArrow ? true : false,
                        mimic: "center"
                    },
                    width:params.width
                },
                show: {
                    delay: params.delayOnShow,
                    event: params.operateManually ? 'click' : 'mouseenter',
                    solo: params.showSolo,
                    ready: params.showOnLoad
                },
                hide: {
                    fixed: true, // !params.closeManually && !params.showOnClick ? true : false,
                    leave: params.operateManually ? true : false,
                    event: params.operateManually ? 'click' : 'mouseleave',
                    delay: params.operateManually ? false : params.delayOnHide
                },
                events: {
                    show: function (event, api) {
                        if ( !params.operateManually && $("#bootstrap-visible-xs").is(":visible")) {
                            event.preventDefault();
                            return;
                        }    
                        
                        if (params.delayOnHide > 0) {
                            $(params.classChange).removeClass(params.classChange);
                            CloseAllQtips();                            
                        }
                        api.elements.target.addClass(params.classChange);
                        if (params.trackEvent == true) {
                            ProductPageEventTrack(params.trackEventName, params.trackEventAction);
                        }
                    },
                    hide: function (event, api) {
                        if (api.elements.target.hasClass(params.classChange)) {
                            api.elements.target.removeClass(params.classChange);
                        }
                    },
                    events: {
                        move: function (event, api, position, viewport) {
                            if (position.adjusted) { position.bottom -= api.options.position.adjust.y }
                        }
                    }
                }
            });
    });
}

/*** Navigation ***/

function InitializeNavigationQTip() {
    $(".showPopUp").each(function () {
        var currentNavigationItem = $(this);

        $(currentNavigationItem)
            .removeData("qtip")
            .qtip({
                overwrite: true,
                prerender: true,
                content: {
                    text: $(currentNavigationItem).children(".navigationPopOut")
                },
                position: {
                    my: "top center",
                    at: "bottom center",
                    target: $("#navigationHeader"),
                    adjust: {
                        method: "shift"
                    }
                },
                style: {
                    width: 1006,
                    classes: 'ui-tooltip-stuller-nav',
                    tip: {
                        corner: false,
                        mimic: "center"
                    }
                },
                show: {
                    delay: 350,
                    event: 'mouseenter'
                },
                hide: {
                    fixed: true,
                    leave: false,
                    event: 'mouseleave',
                    delay: 150
                },
                events: {
                    show: function (event, api) {
                        $(".showPopUp").removeClass("inverted");
                        CloseAllQtips();
                        api.elements.target.addClass("inverted");

                        $(this).find(".qTipNavBarInner:first-child").trigger('mouseenter');
                    },
                    hide: function (event, api) {
                        api.elements.target.removeClass("inverted");
                    },
                    events: {
                        move: function (event, api, position, viewport) {
                            if (position.adjusted) {
                                position.bottom -= api.options.position.adjust.y;
                            }
                        }
                    }
                }
            });
    });
}


/*** CMS Blocks ***/
addStullerEventListener('cms-content-recommendations', function (event) {
    const contentParamArray = event.detail.contentParamArray
    if (typeof contentParamArray == 'undefined' || !contentParamArray.length)
        return;
    $.ajax({
        url: "/cms/richrelevance/getcontents",
        type: "POST",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({ contentDtos: contentParamArray })
    }).done(function (response) { ProcessContentArray(response); });
})

addStullerEventListener('cms-preview-tmc', function (event) {
    var self = $(event.detail.target);
    var ptd = event.detail;

    self.parent().css({ backgroundColor: 'green' })
        .siblings('.preview-tmc-options').css({ backgroundColor: '#333333' });

    $.get(ptd.previewUrl, function (html) {

        var fakeContainer = $("<div/>").html(html);
        var previewTmcData = fakeContainer.children('div:first').data('cms');
        var currentContainer = self.parents('div[data-cms]:first');
        var currentData = currentContainer.data('cms');

        var recursiveRemove = function (contentToRemove) {
            var ccs = $.grep(currentData.ChildContent,
                function (cc) {
                    return cc.ParentInstanceId == contentToRemove.InstanceId;
                });
            $.each(ccs, function (i, cc) {
                recursiveRemove(cc);
            });

            currentData.ChildContent.splice($.inArray(contentToRemove, currentData.ChildContent), 1);
        };

        $.each($.grep(currentData.ChildContent, function (cc) {
            return cc.ParentInstanceId == ptd.instanceId;
        }), function (i, cc) { recursiveRemove(cc); });

        var data = {
            ContentType: previewTmcData.ContentType,
            EditUrl: previewTmcData.EditUrl,
            Title: previewTmcData.Title,
            ContentContainerId: previewTmcData.ContentContainerId,
            ParentContentContainerId: ptd.parentContentContainerId,
            InstanceId: previewTmcData.InstanceId,
            ParentInstanceId: ptd.instanceId
        };

        currentData.ChildContent.push(data);

        $.each(previewTmcData.ChildContent, function (i, cc) {
            currentData.ChildContent.push(cc);
        });

        currentContainer.data('cms', currentData);
        self.parents('.preview-tmc-parent:first').find('.preview-tmc-container').html(fakeContainer.children('div:first').html());
        InitializeCmsQtipOnElement(currentContainer, true);
        InitializeResponsiveCarousel();
    });
})

function ProcessContentArray(getContentResponseArray) {
    if (!getContentResponseArray || getContentResponseArray.length <= 0 ) return;
    for (i = 0; i < getContentResponseArray.length; i++ ){
        var c = getContentResponseArray[i];
        var placeholder = $('#personalize-' + c.id );
        if ( c.cmsData != null ){
            var section = placeholder.parents('.cms_section:first');
            var data = section.data('cms');
            data.ChildContent = data.ChildContent || [];
            for( j = 0; j < c.cmsData.length; j++ ){
                data.ChildContent.push(c.cmsData[j]);
            }
            section.data('cms', data);
            InitializeCmsQtipOnElement(section, false);
        }
        placeholder.parent(':first').attr("data-rr-request", c.request);
        placeholder.replaceWith( c.html );
    }

    if (window.location.href.indexOf('rr_debug=true') != -1) {
        $("[data-rr-request]").each(function () {
            var req = $(this).attr('data-rr-request');
            if ( req )
                $(this).append("<div style='position:absolute; padding: 5px; border:solid 1px #ccc; z-index:9999;background-color:blue; color:#fff;'><a href='javascript:;' onclick='window.prompt(\"Copy to clipboard with Ctrl+C\", \"" + req +
                        "\");'>view RR request url</a></div>");
        });
    }
}

function InitializeCmsQtipOnElement(element, showNow) {
    //var contentBlockId = $(this).attr("data-content_block_id");
    //var cmsLink = $(this).attr("data-editable_link");
    var isEditable = $(element).attr("data-is_editable");
    //var contentContainerId = $(this).attr("data-content_container_id");

    if (isEditable == "TRUE") {

        var data = $(element).data("cms");
        var title = data.ContentContainerId + " - version: " + data.ContentId;

        var container = $("<div/>").css({padding:'5px'});
        var headerTable = $("<table/>").addClass('cms-preview-table').css({ width: '100%', marginBottom: 0 });
        var cols = '<col width="70%"/><col width="30%"/>';
        var headerRow = "<tr><th>Title</th><th>Type</th>";
        headerTable.append(cols).append(headerRow);

        var bodyTable = $("<table/>").addClass('cms-preview-table').css({ width: '100%', marginTop: 0, marginBottom: '20px' });
        bodyTable.append(cols);

        var getBodyRow = function (x, padding) {
            return "<tr><td style='padding-left:" + padding + "px;'><a href='" + x.EditUrl + "'>"
            + $("<span/>").text(x.Title).text()
            + "</a></td><td>"                
            + $("<span/>").text(x.ContentType).text() + "</td></tr>";
        }

        bodyTable.append(getBodyRow(data, 5));
        var processChildren = function (padding, parentInstanceId) {
            var children = $.grep(data.ChildContent || [], function (cc) {
                return cc.ParentInstanceId == parentInstanceId;
            });
            
            $.each(children, function (i, c) {
                bodyTable.append(getBodyRow(c, padding));
                processChildren(padding + 5, c.InstanceId);
            });
        }
        processChildren(10, data.InstanceId);
        container
            .append(headerTable)
            .append($("<div/>")
                .css({ maxHeight: '200px', overflow: 'auto' })
                .append(bodyTable));
        
        $(element)
        .qtip({
            content: {
                text: $("<div/>").append(container).html(),
                title: {
                    text: title,
                    button: true
                }
            },
            position: {
                my: 'bottom center',
                at: 'top center',
                viewport: $(window)
            },
            style: {
                classes: 'ui-tooltip-green'
            },
            hide: {
                fixed: true,
                delay: 250
            },
            show: {
                delay: 250,
                ready: showNow ? true : false
            }
        });
    }
}

function InitializeCMS() {
    $(".cms_editable").each(function () {
        InitializeCmsQtipOnElement(this);
    });
}

/*** Add to Cart Popups ***/

function loadAutoReorder(id) {
    return $.ajaxModal({
        url: "/myaccount/autoreorder/setup/",
        type: "GET",
        data: { productId: id },
        modalCss: "autoReorderModal",
        modalDialogCss: "modal-lg",
        modalTitle: "Auto-Reorder"
    }).error(function() {                        
        $('.stullerAjaxLoader').fadeOut();
        $('.autoReorderError').fadeIn();
    });
}

function GetAddToCartPopupClickEvent(e) {
    e.stopPropagation();
    var $span = $( this ).parents( "span" ).parents( "span" );
    
    var params = {
        addToCartURL: $span.attr("data-addtocarturl"),
        multiAddData: $span.data( "multi-addtocart-popup" ),
        atPosition: $span.attr( "data-addtocart-atposition" ),
        myPosition: $span.attr( "data-addtocart-myposition" ),
        target: $span.attr( "data-addtocart-target" ),
        ignoreWebEnabledFlag: $span.data( "ignorewebenabledflag" ),
        autoReorder: $span.attr( "data-auto-reorder" )
    };

    if (params.multiAddData != null) {
      var items = params.multiAddData.map(x => x.ProductTracking).filter(x => x != null)
      if (items.length > 0) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({ details: null })
        window.dataLayer.push({
          event: 'select_item',
          details: {
            items
          }
        })
      }
    }

    if ( params.autoReorder ) {
        loadAutoReorder( params.multiAddData[0].ProductId );
        return;
    }

    if ( typeof params.addToCartURL != "undefined" ) {
        var data = JSON.stringify( {
            requests: params.multiAddData,
            ignoreWebEnabledFlag: params.ignoreWebEnabledFlag,
            autoReorder: params.autoReorder
        } );

        //this looks like it's never used.  it wasn't used before i changed this code...  ¯\_(ツ)_/¯
        if ( params.source != undefined ) {
            if ( fullUrl.indexOf( "?" ) === -1 ) {
                fullUrl += "?";
            }
            if ( params.source.source != null ) {
                fullUrl += "&recommendationSource=" + params.source.source;
            }
            if ( params.source.sourceType != null ) {
                fullUrl += "&recommendationType=" + params.source.sourceType;
            }
            if ( params.source.sourceId != null ) {
              fullUrl += "&recommendationId=" + params.source.sourceId;
            }
            if (params.source.index != null) {
                fullUrl += "&recommendationIndex=" + params.source.index;
            }
        }

        $.ajaxModal( { url: params.addToCartURL, data: data, modalCss: 'genericAddToCartModal' } );

        if ( typeof $( $( this ).parents( ".mainAddClick" )[0] ).data( "multi-addtocart-popup" ) != 'undefined' &&
            $( this ).parents( ".mainAddClick" ).data( "multi-addtocart-popup" ).length > 1 ) {
            $( '.genericAddToCartModal .modal-dialog' ).addClass( "modal-lg" );
        } else {
            $( '.genericAddToCartModal .modal-dialog' ).removeClass( "modal-lg" );
        }
    }    
}

function InitializeAddToCartPopup() {
    $( ".addclick" ).click( GetAddToCartPopupClickEvent );
}

function InitializeGroupNameEdit() {
    $(".editGroupName").each(function() {
        var thisGroup = $(this);
        $(thisGroup)
        .qtip({
            content: {
                text: $(thisGroup).siblings(".groupEditForm").html(),
                title: {
                    text: 'Edit Group',
                    button: true
                }
            },
            position: {
                target: $(thisGroup),
                adjust: { mouse: false },
                my: 'right center',
                at: 'left center'
            },
            show: {
                event: 'mousedown',
                solo: true
            },
            hide: false,
            style: {
                classes: "ui-tooltip-stuller-green"
            },
            events: {
                show: function(event, api) {
                    if (event.originalEvent.button !== 2) {
                        try {
                            event.preventDefault();
                        } catch(e) {
                        }
                    }
                }
            }
        });
    });
}

function CreatePriceSummaryQtip(element) {
    var container = $(element);
    var content = $(container).children('.priceSummaryQtipContent');
    $(container).qtip({
        content: {
            text: content.html(),
            title: {
                text: 'Price Summary',
                button: true
            }
        },
        position: {
            target: false,
            my: 'right center',
            at: 'left center',
            adjust: {
                method: "shift"
            }
        },
        show: {
            ready:true,
            solo: true,
            event: 'click'
        },
        hide: false,
        style: {
            classes: "ui-tooltip-stuller-white"
        }
    });
}

function CloseAllQtips() {
    $('.qtip :not(.jgrowl), .estShipDate, .priceSummaryQtipContent, .showcaseSummaryQtip, .ui-tooltip-stuller-white').qtip('hide');
}

function InitializeExpandingShowcaseSummaryRows() {
    $(".expandableRow").click(function () {
        var tableElement = $(this).parents(".componentTable");
        var expandElement = $(this).children('.expandMarkup');
        var markupType = $(expandElement).attr("data-markupType");
        var markupTypeString = $(expandElement).attr("data-markupTypeString");
        var settingItemNumber = $(tableElement).attr("data-settingItemNumber");

        TrackMarkupPreviewer("Detail", settingItemNumber + '-' + markupTypeString);

        $(".expanded_" + markupType).toggle();
        var thisSortImage = $(expandElement).children("span");
        if (thisSortImage.hasClass('fa-plus-circle')) {
			thisSortImage.removeClass('fa-plus-circle').addClass('fa-minus-circle');
        } else {
			thisSortImage.removeClass('fa-minus-circle').addClass('fa-plus-circle');
        }
    });
}

function CreateShowcasePriceSummaryQtip() {
    
    var url = $('.showcaseSummaryQtip').children('span').data("showcasesummary-url");
    var formData = $("#addToCartContainer form").find(":input, select, textarea").serializeArray();
    var container = $( ".showcaseSummaryQtip" );    
    $(container)
           .removeData("qtip")
           .qtip({
               content: {
                   text: 'Loading...',
                   title: {
                       text: 'Showcase Pricing Summary',
                       button: true
                   },
                   ajax: {
                       type: "POST",
                       url: url,
                       data:  formData ,
                       dataType: "html",                                        
                       error: function (req, msg, err) {
                           this.set('content.text', msg);
                       },
                       success: function (msg) {
                           this.set('content.text', msg);
                           InitializeExpandingShowcaseSummaryRows();
                       }
                   }
               },
               position: {                   
                   my: 'right top',
                   at: 'left center',
                   target: $('.showcaseSummaryQtip')
               },
               show: {
                   ready: true,
                   solo: true,
                   event: 'click'
               },
               hide: false,
               style: {
                   classes: "ui-tooltip-stuller-white"
               },
               events: {
                   hide: function (event, api) {
                       $(".gemstoneWarning, .estShipDate").qtip('hide');
                   }
               }
           });
}